/**
 * YOSEMITE / CATEGORY
 * ---------------------------------------------------------------------------------------------------------------------
 * このファイルがやることは 5 つだけです。
 *
 *   1. タブをクリックしたときに、ページのスクロール位置を動かさない
 *   2. CATEGORY NAV が横に溢れているときだけ、左右の矢印を出す（PC の大きい矢印、
 *      Mobile 専用カウンターの小さい矢印、どちらも data-yc-prev / data-yc-next を持つ要素として
 *      同じ仕組みで扱う。1 つの NAV に複数の矢印要素が存在してよい）
 *   3. 矢印で NAV を横スクロールする
 *   4. カテゴリーが切り替わったとき、選択中のタブを NAV の見える範囲へ寄せる（横方向のみ）
 *   5. マウス／タッチのクリックと、キーボード操作を区別し、フォーカス表示（hairline）を
 *      キーボード操作のときだけ出す（クリックでは四角い枠や hairline を出さない）
 *
 * やらないこと（意図的に持っていません）
 *   - 商品カードの生成・複製・書き換え（innerHTML / outerHTML / cloneNode / createElement は 1 つも使いません）
 *   - パネルの表示切替（CSS の :checked が担当します。JS が落ちても切替は動きます）
 *   - URL の書き換え（pushState / replaceState / popstate は使いません）
 *   - Section Rendering API の呼び出し（fetch しません）
 *   - window.scrollTo / scrollIntoView / hash 変更
 *
 * キーボード操作とスクリーンリーダー対応は、素の <input type="radio"> のネイティブ挙動に任せています。
 * radio は display:none ではなく visually-hidden なので、Tab で入り ←→↑↓ で移動でき、
 * <fieldset><legend> によってカテゴリー選択のグループであることが読み上げられます。
 */

(function () {
  'use strict';

  if (typeof window.HTMLElement !== 'function') return;

  var SCROLL_STEP_RATIO = 0.8;
  // 選択中タブを NAV 内で見える位置へ寄せる際に残す余白。
  // 24px だと選択タブが端ギリギリに寄ってしまい、直前/直後のタブがほぼ画面外に
  // 消えてしまう（＝進めた後に戻りにくい）ため、タブ 1 個の最小幅の半分弱に相当する
  // 72px を残し、隣のタブが必ず一部見える状態を保つ。
  var EDGE_PADDING = 72;

  /* ------------------------------------------------------------------ CATEGORY NAV */

  function CategoryNav(root) {
    this.root = root;
    this.nav = root.querySelector('[data-yc-nav]');
    if (!this.nav) return;

    this.track = this.nav.querySelector('[data-yc-track]');
    if (!this.track) return;

    // data-yc-prev / data-yc-next を持つ要素はいくつあってもよい。
    // PC 用の大きい矢印（.yc__nav の中）と、Mobile 専用カウンターの小さい矢印
    // （.yc__nav の外、同じ <yosemite-category> の中）の両方をここでまとめて拾う。
    this.prevEls = root.querySelectorAll('[data-yc-prev]');
    this.nextEls = root.querySelectorAll('[data-yc-next]');

    this.onScroll = this.update.bind(this);
    this.onResize = this.update.bind(this);
    this.onChange = this.handleChange.bind(this);
    this.onClick = this.handleClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);
    this.onPrev = this.step.bind(this, -1);
    this.onNext = this.step.bind(this, 1);

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.track.addEventListener('click', this.onClick);
    window.addEventListener('resize', this.onResize, { passive: true });
    root.addEventListener('change', this.onChange);
    // キーボードでの操作（Tab / 矢印キー / Home / End）を検知したら、
    // クリック由来のフォーカス表示抑制（.yc__pointer）を解除する。
    root.addEventListener('keydown', this.onKeydown);

    for (var pi = 0; pi < this.prevEls.length; pi++) this.prevEls[pi].addEventListener('click', this.onPrev);
    for (var ni = 0; ni < this.nextEls.length; ni++) this.nextEls[ni].addEventListener('click', this.onNext);

    if (typeof window.ResizeObserver === 'function') {
      this.observer = new ResizeObserver(this.onResize);
      this.observer.observe(this.track);
    }

    this.update();
  }

  /** 横に溢れているかを測り、矢印（複数あり得る）の表示と有効 / 無効を決める。 */
  CategoryNav.prototype.update = function () {
    if (!this.track) return;

    var overflow = this.track.scrollWidth - this.track.clientWidth;
    this.nav.classList.toggle('is-scrollable', overflow > 1);

    var atStart = this.track.scrollLeft <= 1;
    var atEnd = this.track.scrollLeft >= overflow - 1;
    for (var pi = 0; pi < this.prevEls.length; pi++) this.prevEls[pi].disabled = atStart;
    for (var ni = 0; ni < this.nextEls.length; ni++) this.nextEls[ni].disabled = atEnd;
  };

  /**
   * タブのクリックを横取りして、ページのスクロール位置を動かさずにカテゴリーを切り替える。
   *
   * なぜ必要か
   * ---------------------------------------------------------------------------------------------------------------
   * 切替の実体は隠し <input type="radio"> で、これはセクションの先頭（HERO の上）に置いてあります。
   * CSS の「:checked ~ 後続の兄弟」で切り替えるため、パネルより前に無いと機能しないからです。
   *
   * <label for="…"> を押すと、ブラウザは既定動作として対応する radio に **フォーカスを移します**。
   * その radio は画面外（セクション先頭）にあるため、ブラウザが「フォーカス先を見せる」ために
   * ページ全体をスクロールしてしまいます（実測：scrollY 440 -> 0）。
   *
   * そこで既定動作を止め、こちらで checked を立てて focus({ preventScroll: true }) を呼びます。
   * スクロールを打ち消すのではなく、そもそも発生させません。
   * 触るのは radio の checked と focus だけで、パネルや商品カードの DOM には一切触れていません。
   * JS が読み込まれなかった場合はブラウザの既定動作に戻るだけで、切替自体は CSS で動き続けます。
   *
   * なぜ .yc__pointer を付けるか
   * ---------------------------------------------------------------------------------------------------------------
   * クリックされたのは <label> で radio ではないため、ここで呼ぶ focus() はブラウザから見ると
   * 「クリックされた要素そのものへのネイティブなフォーカス」ではなく「スクリプトによるフォーカス」に見えます。
   * そのため一部のブラウザでは :focus-visible が誤って true になり、
   * マウスやタッチでクリックしただけなのにキーボード用のフォーカス表示（hairline）が出てしまいます。
   * これを防ぐため、クリックの瞬間だけ <yosemite-category> に .yc__pointer を付けて
   * そのフォーカス表示を打ち消し、実際にキーボード（Tab / 矢印キー等）が使われたら
   * handleKeydown 側で外します。商品カードや panel の DOM には一切触れていません。
   */
  CategoryNav.prototype.handleClick = function (event) {
    var label = event.target.closest ? event.target.closest('.yc__tab') : null;
    if (!label || !label.htmlFor) return;

    // getElementById を使うのは、Shopify のセクション ID に含まれる `--` や `__` を
    // CSS セレクタとしてエスケープする必要が無く、確実だからです。
    var radio = document.getElementById(label.htmlFor);
    if (!radio || !this.root.contains(radio)) return;

    event.preventDefault();

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.root.classList.add('yc__pointer');
    radio.focus({ preventScroll: true });
  };

  /**
   * キーボードでの操作を検知して、クリック由来のフォーカス表示抑制を解除する。
   * Tab / Shift+Tab や矢印キー・Home・End でカテゴリー間を移動するのは、
   * すべて radio のネイティブ挙動（このファイルは関与しません）。
   * ここではその「今キーボードが使われた」という事実だけを見ています。
   */
  CategoryNav.prototype.handleKeydown = function (event) {
    var key = event.key;
    if (key === 'Tab' || key === 'ArrowLeft' || key === 'ArrowRight' ||
        key === 'ArrowUp' || key === 'ArrowDown' || key === 'Home' || key === 'End') {
      this.root.classList.remove('yc__pointer');
    }
  };

  /** 矢印クリック。1 回でトラック幅の 80% ぶん動かす。 */
  CategoryNav.prototype.step = function (direction) {
    this.track.scrollBy({
      left: this.track.clientWidth * SCROLL_STEP_RATIO * direction,
      behavior: 'smooth'
    });
  };

  /**
   * カテゴリーが切り替わったら、そのタブを NAV の見える範囲に寄せる。
   * scrollIntoView はページ全体を縦にも動かしてしまうため、
   * トラックの scrollLeft だけを自前で計算して動かしています。
   */
  CategoryNav.prototype.handleChange = function (event) {
    var radio = event.target;
    if (!radio || radio.type !== 'radio') return;

    var index = radio.getAttribute('data-yc-index');
    if (index === null) return;

    var tab = this.track.querySelector('.yc__tab[data-yc-index="' + index + '"]');
    if (!tab) return;

    var trackBox = this.track.getBoundingClientRect();
    var tabBox = tab.getBoundingClientRect();

    if (tabBox.left < trackBox.left + EDGE_PADDING) {
      this.track.scrollBy({ left: tabBox.left - trackBox.left - EDGE_PADDING, behavior: 'smooth' });
    } else if (tabBox.right > trackBox.right - EDGE_PADDING) {
      this.track.scrollBy({ left: tabBox.right - trackBox.right + EDGE_PADDING, behavior: 'smooth' });
    }
  };

  CategoryNav.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.track) this.track.removeEventListener('click', this.onClick);
    if (this.root) this.root.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('resize', this.onResize);
  };

  /* ------------------------------------------------------------------ カスタム要素 */

  var YosemiteCategory = class extends HTMLElement {
    connectedCallback() {
      if (this.ycNav) return;
      this.ycNav = new CategoryNav(this);
    }

    disconnectedCallback() {
      if (this.ycNav && this.ycNav.destroy) this.ycNav.destroy();
      this.ycNav = null;
    }
  };

  if (!window.customElements.get('yosemite-category')) {
    window.customElements.define('yosemite-category', YosemiteCategory);
  }

  /* ------------------------------------------------------------------ Theme Editor 対応
   * 非表示パネルの中にあるブロックを Theme Editor で選んだとき、そのカテゴリーへ切り替えます。
   * これがないと「ブロックを選んでも何も見えない」状態になります。
   * 触るのは radio の checked だけで、商品カードの DOM には一切手を出しません。
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      var el = event.target;
      if (!el || typeof el.closest !== 'function') return;

      var section = el.closest('yosemite-category');
      if (!section) return;

      var holder = el.hasAttribute('data-yc-index') ? el : el.closest('[data-yc-index]');
      if (!holder) return;

      var radio = section.querySelector('input.yc__radio[data-yc-index="' + holder.getAttribute('data-yc-index') + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
})();
